export function scheduleIdle(fn: () => void, timeoutMs = 600) {
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(fn, { timeout: timeoutMs });
  } else {
    setTimeout(fn, 0);
  }
}

let hudRefreshTimer: ReturnType<typeof setTimeout> | null = null;
let hudRefreshPending = false;

export function coalesceHudRefresh(emit: () => void) {
  hudRefreshPending = true;
  if (hudRefreshTimer) return;
  hudRefreshTimer = setTimeout(() => {
    hudRefreshTimer = null;
    if (hudRefreshPending) {
      hudRefreshPending = false;
      emit();
    }
  }, 16);
}
